import { IncentiveCampaignValidRegistrationFieldsType } from 'domains/loyalty';

export function isInvalidChallengeMember(
  validations?: IncentiveCampaignValidRegistrationFieldsType | null
): boolean {
  if (validations == null) return false;
  return validations.name === false;
}
